/* so-variant-drawer.js
   Bolt-on: for each <so-variant-drawer>, hide the matching native option grid,
   relocate a compact trigger into the fieldset, and open a right-side searchable
   drawer whose rows proxy selection to the native variant-picker radios.
   Never maintains a parallel source of truth — price/availability/pre-order all
   come from (or are driven through) the native picker. */
(function () {
  'use strict';

  // F2: one stock vocabulary (assets/so-stock-state.js, loaded in <head>).
  function soPreShip() { var s = window.SO && SO.stock ? SO.stock.shipText('pre', null, null, true) : ''; return s ? ' · ' + s : ''; }
  function soRowTag(qty, policy, notify, unit) {
    if (!(window.SO && SO.stock)) return qty > 0 ? 'In stock' : (policy === 'continue' ? 'Pre-order' : 'Out of stock');
    return SO.stock.label(SO.stock.classify({ tracked: true, policy: policy, qty: qty }, SO.stock.lowAt()), 'row', { notify: !!notify, unit: unit });
  }

  // This asset can be enqueued twice on one page (once by the PDP so_variant_drawer block, once
  // globally by quick-add-drawer.liquid). Run the IIFE only once.
  if (window.__soVdLoaded) return;
  window.__soVdLoaded = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function textVal(input) { return input ? input.value : ''; }

  function initOne(host) {
    if (host.dataset.soVdReady) return;
    // Scope the picker to THIS drawer's context so the quick-add slide-up drives its own copied
    // variant-picker (not the PDP's, if both exist). Falls back to document for safety.
    var scope = host.closest('quick-add-drawer, .product-info, .product, main') || document;
    var picker = scope.querySelector('variant-picker');
    if (!picker) return;
    var inQuickAdd = !!host.closest('quick-add-drawer');
    // P0-2B (Charl 2026-09-25): on the PDP a sold-out flavour can be selected so its "email me
    // when it's back" form (so-stock-alert, which follows the selected variant) can be used.
    // Quick-add has no notify form, and a sold-out BUNDLE value stays blocked: its variants
    // continue-sell, so selecting one would offer a pre-order of a bundle we can't make (bundle
    // pre-order rows — every short part pre-orderable — stay selectable).
    var canNotify = !inQuickAdd && !!scope.querySelector('[data-so-stock-alert]');

    var rows = Array.prototype.slice.call(host.querySelectorAll('.so-vd__row'));
    var wantValues = rows.map(function (r) { return r.getAttribute('data-value'); });

    // Match the native fieldset whose .js-option values are the same set as our rows.
    var fieldsets = Array.prototype.slice.call(picker.querySelectorAll('.option-selector[data-selector-type="listed"]'));
    var fieldset = null;
    fieldsets.forEach(function (fs) {
      var vals = Array.prototype.slice.call(fs.querySelectorAll('.js-option')).map(textVal);
      if (vals.length === wantValues.length && wantValues.every(function (v) { return vals.indexOf(v) !== -1; })) {
        fieldset = fs;
      }
    });
    if (!fieldset) return;

    host.dataset.soVdReady = '1';
    var btns = fieldset.querySelector('.option-selector__btns');
    if (btns) { btns.classList.add('so-vd-native-hidden'); btns.setAttribute('aria-hidden', 'true'); }
    // A <fieldset>'s default min-width:min-content otherwise balloons to the trigger's
    // (nowrap) intrinsic width on narrow screens, overflowing the card. Let it shrink.
    fieldset.style.minWidth = '0';
    // The grid's pre-order legend is redundant now (drawer tags each pre-order row) and
    // plain wrong on bundles (they can't pre-order) — hide it wherever the drawer is active.
    var preLegend = fieldset.querySelector('.so-option-preorder-legend');
    if (preLegend) { preLegend.style.display = 'none'; }

    // Map option value -> native radio input
    var inputByValue = {};
    Array.prototype.slice.call(fieldset.querySelectorAll('.js-option')).forEach(function (inp) {
      inputByValue[inp.value] = inp;
    });
    // Pre-order values from the native labels (single products). Bundles: bundleRowState() below.
    var isBundle = host.getAttribute('data-is-bundle') === 'true';
    var lowThreshold = window.SO && SO.stock ? SO.stock.lowAt() : parseInt(host.getAttribute('data-threshold-low'), 10);
    var rowUnit = host.getAttribute('data-unit') || ''; // F2 R2: "packs" noun (ZYN etc.)
    var preorderValues = {};
    if (!isBundle) {
      Array.prototype.slice.call(fieldset.querySelectorAll('[data-so-preorder-value]')).forEach(function (lbl) {
        var forId = lbl.getAttribute('for');
        var inp = forId ? document.getElementById(forId) : lbl.querySelector('.js-option');
        if (inp) preorderValues[inp.value] = true;
      });
    }

    // Bundles: a continue-selling bundle variant reads "available" natively even when its
    // components are out, so native availability can't flag Sold out. Use the variant-picker's
    // {{ product | json }} + its "formatted" map (inventory === 'none' when qty <= 0) — a
    // policy-independent stock signal — to mark sold-out flavours regardless of inventory policy.
    var vpVariants = null, vpFormatted = null, vpOptionNames = null, thisOptIdx = -1;
    function loadVp() {
      if (!isBundle) return;
      var vpScript = picker.querySelector('script[type="application/json"]');
      var vpData = null;
      try { vpData = vpScript ? JSON.parse(vpScript.textContent) : null; } catch (e) { vpData = null; }
      if (vpData && vpData.product && vpData.product.variants) {
        vpVariants = vpData.product.variants;
        vpFormatted = vpData.formatted || {};
        vpOptionNames = vpData.product.options || [];
        thisOptIdx = vpOptionNames.indexOf(host.getAttribute('data-opt-name'));
      }
    }
    loadVp();
    function currentOptionSel() {
      var sel = vpOptionNames.map(function () { return null; });
      Array.prototype.slice.call(picker.querySelectorAll('.option-selector')).forEach(function (fs, i) {
        var c = fs.querySelector('.js-option:checked');
        if (c && i < sel.length) sel[i] = c.value;
      });
      return sel;
    }
    // 2026-10-13 (Charl): bundles CAN pre-order. With the component stock the page carries
    // (so-preorder-data, data-so-bundle-parts; same rule as SoPreorderPdp.bundleState) a row is
    // 'in' when any matching variant is in stock, else 'pre' when any is pre-orderable, else 'out'.
    // Returns null without that data — bundleSoldOut() below then decides, and nothing pre-orders.
    var bundleParts = null;
    if (isBundle) {
      var partsEl = scope.querySelector('[data-so-bundle-parts]');
      try { bundleParts = partsEl ? JSON.parse(partsEl.textContent) : null; } catch (e) { bundleParts = null; }
    }
    // One rule for the drawer, the stock line and the buy button: SoPreorderPdp.bundleState
    // (so-preorder-pdp.js). null = unknown (a part matched no option value, or that script is not loaded).
    function partsState(opts) {
      var Pdp = window.customElements && customElements.get('so-preorder-pdp');
      return Pdp && Pdp.bundleState ? Pdp.bundleState(bundleParts, opts) : null;
    }
    // Each row shows the stock of the PART it picks (colour row = device, coil row = pods, flavour
    // row = e-liquid), not the whole bundle: with Ranger Green (device at 0) chosen, every coil row
    // read "Pre-order" though the pods were in stock (Charl 2026-10-14). The stock line above the buy
    // button still gives the whole bundle's state. Falls back to the combination when no part has
    // this value (e.g. an option the parts data doesn't cover).
    function partRowState(value, cur) {
      var e = null;
      bundleParts.forEach(function (p) {
        if (e || !p || !p.v || p.single) return;
        if (Object.prototype.hasOwnProperty.call(p.v, value)) e = p.v[value];
      });
      if (!e) return null;
      if (!e[3] || e[1] > 0) return 'in';
      if (!e[0] || e[2]) return 'out';
      // Shopify will not sell a stop-selling bundle variant, so 'pre' needs a sellable match.
      var sellable = false;
      vpVariants.forEach(function (v) {
        if (sellable || !v.options || v.options[thisOptIdx] !== value) return;
        for (var q = 0; q < vpOptionNames.length; q++) {
          if (q !== thisOptIdx && cur[q] != null && v.options[q] !== cur[q]) return;
        }
        if (v.available !== false) sellable = true;
      });
      return sellable ? 'pre' : 'out';
    }
    function bundleRowState(value, cur) {
      if (!bundleParts || !vpVariants || thisOptIdx < 0) return null;
      cur = cur || currentOptionSel();
      var own = partRowState(value, cur);
      if (own) return own;
      var best = null;
      vpVariants.forEach(function (v) {
        if (!v.options || v.options[thisOptIdx] !== value) return;
        for (var p = 0; p < vpOptionNames.length; p++) {
          if (p === thisOptIdx) continue;
          if (cur[p] != null && v.options[p] !== cur[p]) return;
        }
        var st = partsState(v.options);
        if (st == null) return; // unknown: if nothing is known, bundleSoldOut() (Shopify's own availability) decides
        if (st === 'pre' && v.available === false) st = 'out'; // Shopify will not sell it
        if (st === 'in' || (st === 'pre' && best !== 'in') || best == null) best = st;
      });
      return best;
    }
    // A flavour is sold out for the bundle when EVERY matching variant (the current selection of
    // the other options, this option = `value`) is out of stock. Unselected options act as wildcards.
    function bundleSoldOut(value) {
      if (!vpVariants || thisOptIdx < 0) return false;
      var cur = currentOptionSel();
      var matched = vpVariants.filter(function (v) {
        if (!v.options || v.options[thisOptIdx] !== value) return false;
        for (var p = 0; p < vpOptionNames.length; p++) {
          if (p === thisOptIdx) continue;
          if (cur[p] != null && v.options[p] !== cur[p]) return false;
        }
        return true;
      });
      if (!matched.length) return false;
      return matched.every(function (v) {
        var f = vpFormatted[v.id];
        return !!(f && f.inventory === 'none');
      });
    }

    var trigger = host.querySelector('.so-vd__trigger');
    var drawer = host.querySelector('.so-vd__drawer');
    var backdrop = host.querySelector('.so-vd__backdrop');
    var search = host.querySelector('.so-vd__search');
    var list = host.querySelector('.so-vd__list');
    var noResults = host.querySelector('.so-vd__noresults');
    var summaryEl = drawer.querySelector('.so-vd__summary');
    var filtersEl = drawer.querySelector('.so-vd__filters');
    var filterBtns = Array.prototype.slice.call(drawer.querySelectorAll('.so-vd__filter'));
    var triggerPre = trigger.querySelector('.so-vd__trigger-pre');
    var curFilter = 'all', curQuery = '';

    // Move trigger into the fieldset (after its legend); portal drawer+backdrop to body
    var legend = fieldset.querySelector('.option-selector__label, legend');
    if (legend && legend.parentNode) legend.parentNode.insertBefore(trigger, legend.nextSibling);
    else fieldset.appendChild(trigger);
    // In the quick-add slide-up, tag the portaled overlay so quick-add.js can sweep stale copies
    // when the drawer is re-opened for another product (avoids body pile-up).
    if (inQuickAdd) { drawer.setAttribute('data-so-vd-qa', ''); backdrop.setAttribute('data-so-vd-qa', ''); }
    document.body.appendChild(drawer);
    document.body.appendChild(backdrop);
    host.removeAttribute('hidden');

    // Build the trigger teaser from the first 4 row thumbnails
    var teaser = trigger.querySelector('.so-vd__teaser');
    rows.slice(0, 4).forEach(function (r) {
      var img = r.querySelector('img');
      var mini = document.createElement('span');
      mini.className = 'so-vd__teaser-thumb';
      if (img) mini.style.backgroundImage = 'url("' + img.src + '")';
      teaser.appendChild(mini);
    });

    function rowByValue(v) { return rows.filter(function (r) { return r.getAttribute('data-value') === v; })[0]; }

    function syncState() {
      var syncCur = isBundle ? currentOptionSel() : null; // once per sync, not once per row
      var checked = Array.prototype.slice.call(fieldset.querySelectorAll('.js-option')).filter(function (i) { return i.checked; })[0];
      var selValue = checked ? checked.value : null;

      rows.forEach(function (r) {
        var v = r.getAttribute('data-value');
        var inp = inputByValue[v];
        var nativeUnavail = inp ? (inp.disabled || inp.getAttribute('aria-disabled') === 'true') : false;
        var bState = isBundle ? bundleRowState(v, syncCur) : null;
        var isPre = !!preorderValues[v] || bState === 'pre';
        var bundleOOS = isBundle && (bState ? bState === 'out' : bundleSoldOut(v));
        // Stock-based sold-out: a tracked, non-pre-order value at 0 qty is sold out even if the
        // theme hasn't disabled its radio yet (dynamic availability only runs on selection).
        var stock = parseInt(r.getAttribute('data-stock'), 10);
        var rowPolicy = r.getAttribute('data-policy');
        if (rowPolicy !== 'continue' && rowPolicy !== 'deny') rowPolicy = 'deny';
        var stockSoldOut = !isBundle && !isPre && !isNaN(stock) && stock <= 0;
        var unavailable = bundleOOS || stockSoldOut || (nativeUnavail && !isPre);

        r.classList.toggle('is-selected', v === selValue);
        r.setAttribute('aria-selected', v === selValue ? 'true' : 'false');
        r.classList.toggle('is-unavailable', unavailable);
        r.classList.toggle('is-notify', unavailable && canNotify && !bundleOOS);
        r.classList.toggle('is-preorder', isPre);

        var tag = r.querySelector('.so-vd__row-tag');
        r.classList.remove('is-instock', 'is-lowstock');
        // R7: rows are quiet. `in` rows carry just their count ("34 in stock", Charl 2026-10-12);
        // `low` rows get the R2 row label; `pre` rows just say "Pre-order" (the group header
        // carries the date); `gone` rows (incl. bundle sold-out) say "Out of stock".
        if (isPre) {
          tag.textContent = 'Pre-order'; tag.hidden = false;
        } else if (unavailable) {
          tag.textContent = soRowTag(0, 'deny', !bundleOOS && canNotify); tag.hidden = false;
        } else if (!isNaN(stock) && stock > 0) {
          // In stock with an unambiguous per-variant count (data-stock + data-policy, emitted
          // together for the same single-tracked-variant value — R2's continue/deny split).
          if (!isNaN(lowThreshold) && lowThreshold > 0 && stock <= lowThreshold) {
            tag.textContent = soRowTag(stock, rowPolicy, false, rowUnit); tag.hidden = false; r.classList.add('is-lowstock');
          } else {
            // Every in-stock row shows its count (Charl 2026-10-12): "34 in stock" / "12 packs in stock".
            tag.textContent = soRowTag(stock, rowPolicy, false, rowUnit); tag.hidden = false; r.classList.add('is-instock');
          }
        } else { tag.hidden = true; }
      });

      // Group by availability (Available now → Pre-order → Unavailable) with headers + summary.
      applyView();

      // Update the trigger to reflect selection (or prompt)
      var thumb = trigger.querySelector('.so-vd__trigger-thumb');
      var name = trigger.querySelector('.so-vd__trigger-name');
      if (selValue) {
        var selRow = rowByValue(selValue);
        var selImg = selRow && selRow.querySelector('img');
        thumb.style.backgroundImage = selImg ? 'url("' + selImg.src + '")' : '';
        thumb.classList.toggle('is-empty', !selImg);
        name.textContent = selValue;
        trigger.classList.add('is-selected');
        var selPre = !!preorderValues[selValue] || (isBundle && selValue != null && bundleRowState(selValue, syncCur) === 'pre');
        if (triggerPre) triggerPre.hidden = !selPre;
        trigger.classList.toggle('is-preorder', selPre);
      } else {
        thumb.style.backgroundImage = '';
        thumb.classList.add('is-empty');
        name.textContent = 'Choose your ' + (host.getAttribute('data-opt-name') || 'option').toLowerCase();
        trigger.classList.remove('is-selected');
        if (triggerPre) triggerPre.hidden = true;
        trigger.classList.remove('is-preorder');
      }
    }

    // Bottom sheet (mobile) must stay above the on-screen keyboard. `position:fixed;
    // bottom:0` anchors to the LAYOUT viewport, which the keyboard overlaps — so when the
    // search field is focused the lower rows fall behind it. Track the VISUAL viewport and
    // lift + size the sheet to the space that's actually visible while a keyboard is open.
    function isMobile() { return window.matchMedia('(max-width: 767px)').matches; }
    function applyViewport() {
      var vv = window.visualViewport;
      if (!isMobile() || !vv) { drawer.style.bottom = ''; drawer.style.maxHeight = ''; return; }
      var gap = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
      if (gap > 60) {                      // keyboard (not just a toolbar) is open
        drawer.style.bottom = gap + 'px';
        drawer.style.maxHeight = Math.round(vv.height) + 'px';
      } else {                             // keyboard closed → fall back to the CSS default (88vh)
        drawer.style.bottom = '';
        drawer.style.maxHeight = '';
      }
    }

    // Open / close
    var lastFocus = null;
    function onKey(e) { if (e.key === 'Escape') close(); }
    function setFilterActive(mode) {
      curFilter = mode;
      filterBtns.forEach(function (b) {
        var on = b.getAttribute('data-filter') === mode;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function open() {
      curQuery = ''; setFilterActive('all');
      if (search) search.value = '';
      syncState();
      lastFocus = document.activeElement;
      drawer.hidden = false; backdrop.hidden = false;
      void drawer.offsetWidth; // force reflow so the transition animates from the closed state
      drawer.classList.add('is-open'); backdrop.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      trigger.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', onKey);
      // Phones: swipe down to close (shared assets/so-sheet-swipe.js; the ::before grab bar is the affordance).
      if (window.soSheetSwipe) window.soSheetSwipe.attach(drawer, { handle: '.so-vd__header', scroller: '.so-vd__list', backdrop: backdrop, onClose: close });
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', applyViewport);
        window.visualViewport.addEventListener('scroll', applyViewport);
      }
      (drawer.querySelector('.is-selected') || drawer).focus();
    }
    function close() {
      drawer.classList.remove('is-open'); backdrop.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKey);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', applyViewport);
        window.visualViewport.removeEventListener('scroll', applyViewport);
      }
      setTimeout(function () {
        drawer.hidden = true; backdrop.hidden = true;
        drawer.style.bottom = ''; drawer.style.maxHeight = ''; // reset the viewport overrides
      }, 250);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function pick(value) {
      var inp = inputByValue[value];
      if (!inp) return;
      var row = rowByValue(value);
      if (row && row.classList.contains('is-unavailable') && !row.classList.contains('is-notify')) return; // block unavailable (sold-out PDP flavours stay pickable for notify-me)
      inp.checked = true;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
      close();
    }

    function rowMatchesFilter(r) {
      if (curFilter === 'instock') return !r.classList.contains('is-preorder') && !r.classList.contains('is-unavailable');
      if (curFilter === 'preorder') return r.classList.contains('is-preorder');
      return true;
    }
    function makeHeader(mod, label) {
      var li = document.createElement('li');
      li.className = 'so-vd__group so-vd__group--' + mod;
      li.setAttribute('role', 'presentation');
      li.textContent = label;
      return li;
    }
    // Single source of layout: applies the search query + availability filter, buckets the visible
    // rows into Available now / Pre-order / Unavailable, and lays them out with section headers.
    // Headers + filter chips + summary only appear when the product actually has a pre-order mix.
    function applyView() {
      var allAvail = 0, allPre = 0, allUn = 0;
      rows.forEach(function (r) {
        if (r.classList.contains('is-unavailable')) allUn++;
        else if (r.classList.contains('is-preorder')) allPre++;
        else allAvail++;
      });
      // Group whenever there's a mix of availability states (in stock / pre-order / sold out).
      var grouped = ((allAvail > 0 ? 1 : 0) + (allPre > 0 ? 1 : 0) + (allUn > 0 ? 1 : 0)) > 1;

      var visAvail = [], visPre = [], visUn = [];
      rows.forEach(function (r) {
        var matchSearch = r.getAttribute('data-value').toLowerCase().indexOf(curQuery) !== -1;
        var vis = matchSearch && rowMatchesFilter(r);
        r.hidden = !vis;
        if (!vis) return;
        if (r.classList.contains('is-unavailable')) visUn.push(r);
        else if (r.classList.contains('is-preorder')) visPre.push(r);
        else visAvail.push(r);
      });

      Array.prototype.slice.call(list.querySelectorAll('.so-vd__group')).forEach(function (h) { h.remove(); });
      if (grouped && visAvail.length) list.appendChild(makeHeader('now', 'Available now · ' + visAvail.length));
      visAvail.forEach(function (r) { list.appendChild(r); });
      if (grouped && visPre.length) list.appendChild(makeHeader('pre', 'Pre-order' + soPreShip() + ' · ' + visPre.length));
      visPre.forEach(function (r) { list.appendChild(r); });
      if (visUn.length) {
        if (grouped) list.appendChild(makeHeader('un', 'Currently unavailable · ' + visUn.length));
        visUn.forEach(function (r) { list.appendChild(r); });
      }

      if (noResults) noResults.hidden = (visAvail.length + visPre.length + visUn.length) > 0;
      if (summaryEl) {
        if (grouped) {
          var parts = [];
          if (allAvail) parts.push(allAvail + ' available now');
          if (allPre) parts.push(allPre + ' pre-order');
          if (allUn) parts.push(allUn + ' sold out');
          summaryEl.textContent = parts.join(' · ');
          summaryEl.hidden = false;
        } else summaryEl.hidden = true;
      }
      // Filter chips appear on any mix; the Pre-order chip only when there are pre-order rows.
      if (filtersEl) filtersEl.hidden = !grouped;
      filterBtns.forEach(function (b) {
        if (b.getAttribute('data-filter') === 'preorder') b.hidden = allPre === 0;
      });
    }

    trigger.addEventListener('click', open);
    backdrop.addEventListener('click', close);
    drawer.addEventListener('click', function (e) { if (e.target.closest('[data-so-vd-close]')) close(); });
    if (search) search.addEventListener('input', function () { curQuery = search.value.trim().toLowerCase(); applyView(); });
    filterBtns.forEach(function (b) {
      b.addEventListener('click', function () { setFilterActive(b.getAttribute('data-filter')); applyView(); });
    });
    list.addEventListener('click', function (e) {
      var r = e.target.closest('.so-vd__row'); if (r) pick(r.getAttribute('data-value'));
    });
    list.addEventListener('keydown', function (e) {
      var r = e.target.closest('.so-vd__row');
      if (r && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); pick(r.getAttribute('data-value')); }
    });

    // Keep in sync with any variant change (native, URL, or our proxy)
    picker.addEventListener('change', syncState);
    syncState();
    // 2026-10-13: variant-picker.js merges variants past the first 250 into the picker's JSON
    // (products with more than 250 variants) and announces it; re-read and re-mark the rows.
    document.addEventListener('so:variants:extended', function () { loadVp(); syncState(); });
  }

  ready(function () {
    Array.prototype.slice.call(document.querySelectorAll('so-variant-drawer.so-vd')).forEach(initOne);
  });

  // Init hook for the quick-add slide-up: it copies the server-rendered <so-variant-drawer> markup
  // into its content, then calls this to upgrade the fresh instances (they miss the DOMContentLoaded
  // scan). Idempotent via the per-host dataset.soVdReady guard.
  window.SoVariantDrawer = window.SoVariantDrawer || {
    initRoot: function (root) {
      Array.prototype.slice.call((root || document).querySelectorAll('so-variant-drawer.so-vd')).forEach(initOne);
    }
  };
})();
